import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { NormalStockPriceI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import StockPutInPrefab from "./StockPutInPrefab ";

const { ccclass, property } = cc._decorator;

@ccclass
export default class StockBuyPrefab extends cc.Component {
    @property(cc.Label)
    stockName: cc.Label = null

    @property(cc.Label)
    stockPrice: cc.Label = null

    @property(cc.Label)
    stockCount: cc.Label = null

    @property(cc.Label)
    stockRemain: cc.Label = null

    @property(cc.Node)
    centerNode: cc.Node = null

    @property(cc.Node)
    reduceBtn: cc.Node = null

    @property(cc.Node)
    addBtn: cc.Node = null

    stockBuyCount: number = 1

    increment: number = 1

    isBuy: boolean = false
    normalStockPriceI: NormalStockPriceI
    bindData(normalStockPriceI: NormalStockPriceI, isBuy: boolean = false) {
        this.isBuy = isBuy
        this.normalStockPriceI = normalStockPriceI;
        this.stockName.string = normalStockPriceI.name;
        this.onChangeStockCount()
        this.reduceBtn.on(cc.Node.EventType.TOUCH_START, this.onReduceStart, this)
        this.addBtn.on(cc.Node.EventType.TOUCH_START, this.onAddStart, this)
        this.reduceBtn.on(cc.Node.EventType.TOUCH_END, this.onTouchEnd, this)
        this.addBtn.on(cc.Node.EventType.TOUCH_END, this.onTouchEnd, this)
        this.reduceBtn.on(cc.Node.EventType.TOUCH_CANCEL, this.onTouchEnd, this)
        this.addBtn.on(cc.Node.EventType.TOUCH_CANCEL, this.onTouchEnd, this)
    }

    onChangeStockCount() {
        this.stockPrice.string = data_control.getNumberFormat(this.normalStockPriceI.price * this.stockBuyCount) + `元`;
        this.stockCount.string = this.stockBuyCount.toString();
        this.stockRemain.string = `(还剩下：${(this.normalStockPriceI.count - this.stockBuyCount)}股)`;
    }

    onAddStock() {
        let coin = O1HD.getServices().userSrv.getCoins()
        if (this.normalStockPriceI.price > coin){

            NormalGameManager._instance.openBankPage();
            return;
        } 
        this.stockBuyCount += this.increment
        this.increment += this.increment;

        if (this.stockBuyCount * this.normalStockPriceI.price > coin) {
            this.stockBuyCount = Math.floor(coin / this.normalStockPriceI.price)
        }
        if (this.stockBuyCount >= this.normalStockPriceI.count) {
            this.stockBuyCount = this.normalStockPriceI.count;
        }
        this.onChangeStockCount()
    }

    onReduceStock() {
        this.stockBuyCount -= this.increment
        this.increment += this.increment;
        if (this.stockBuyCount <= 1) {
            this.stockBuyCount = 1;
        }
        this.onChangeStockCount()
    }

    onReduceStart() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.schedule(this.onReduceStock, 0.1, 999999, 0.5)
    }

    onAddStart() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.schedule(this.onAddStock, 0.1, 999999, 0.5)
    }

    onTouchEnd() {
        this.unscheduleAllCallbacks()
        this.increment = 1
    }

    onBuyStock() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let coin = O1HD.getServices().userSrv.getCoins()
        if (this.normalStockPriceI.price > coin) {
            O1HD.getModules().uiControlModule.showMessageBox("钱不够！");
            
            NormalGameManager._instance.openBankPage();
            return
        }
        O1HD.getServices().userSrv.setCoins(-(this.stockBuyCount * this.normalStockPriceI.price), true)
        NormalGameManager._instance.onStockCountChange(this.normalStockPriceI.id, this.stockBuyCount)
        this.node.destroy();
        O1HD.emit(StockPutInPrefab.CHANGE_STOCK_COUNT, this.isBuy)
    }

    onCloseBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        cc.tween(this.centerNode).to(.5, { scale: 0 }, { easing: cc.easing.backIn }).call(() => {
            this.node.destroy();
            this.reduceBtn.off(cc.Node.EventType.TOUCH_START)
            this.addBtn.off(cc.Node.EventType.TOUCH_START)
            this.reduceBtn.off(cc.Node.EventType.TOUCH_END)
            this.addBtn.off(cc.Node.EventType.TOUCH_END)
            this.reduceBtn.off(cc.Node.EventType.TOUCH_CANCEL)
            this.addBtn.off(cc.Node.EventType.TOUCH_CANCEL)
        }).start();
    }

}
